<template>
  <nav
    class="navbar-secondary"
    :class="[navbarTypeClassName, country === 'de' || country === 'at' || country === 'fr' ? 'exception' : null]"
  >
    <div
      class="transition hidden lg:block absolute top-0 left-0 w-100 h-100"
      :class="backgroundColor"
    />
    <ClubHeader v-if="isClub" />
    <MixitPlusHeader v-if="isMixitPlus" />
    <div class="navbar-secondary__menus container">
      <!-- if megamenu is not displayed on desktop make space gap for wave -->
      <div
        v-if="!megaMenuClassName.includes('lg:block')"
        class="py-6 my-3 hidden lg:block"
      />

      <Megamenu
        v-if="!BrowserService.isMobile() || isHome"
        :id="megaMenuId"
        :class="megaMenuClassName"
      />
    </div>
    <HomeHeader v-if="isHome" />
    <Wave
      path="navbarSecondary"
      :color="waveColor"
      :class="waveClassName"
      class="zindex-10"
    />
  </nav>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useCountry } from '@/mixins/useCountry'

import ClubHeader from '@/components/club/ClubHeader.vue'
import Wave from '@/components/general/BaseWave.vue'
import HomeHeader from '@/components/home/HomeHeader.vue'
import BrowserService from '@/services/browserService'
import { useNavbarStore } from '@/stores/NavbarStore'
import MixitPlusHeader from "@/components/mixit_plus/MixitPlusHeader.vue";
import Megamenu from '../megamenu/TheMegamenu.vue'

const route = useRoute()
const isOpened = ref(false)
const country = useCountry()

const navbarStore = useNavbarStore()

const { isHome, megaMenuId, megaMenuClassName, isClub, isMixitPlus, waveColor, backgroundColor } = storeToRefs(navbarStore)

const navbarTypeClassName = computed(() => `navbar-secondary--${megaMenuId.value}`)

const waveClassName = computed(() => (isHome.value ? '' : 'hidden lg:block'))

watch(
  () => route,
  () => {
    isOpened.value = false
  },
)
</script>

<style lang="scss" scoped>
.transition {
  transition: background-color 0.5s ease;
}
.py-6 {
  padding-bottom: 2.75rem !important;
}
</style>
